import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './TauriAboutUs.css';

const TauriAboutUs = ({ show, onHide }) => {
    return (
        <div>
            <Modal
                show={show}
                onHide={onHide}
                className="about-us-section"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>About Us</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="team-members">
                        <div className="team-member">
                            <div className="name">Joseph Lawrence Carpio</div>
                            <span className="title">Solutions Architect / Principal Engineer</span>
                        </div>
                        <div className="team-member">
                            <div className="name">Benedict Caoili</div>
                            <span className="title">Senior Data Engineer / QA</span>
                        </div>
                        <div className="team-member">
                            <div className="name">Mc Vageau Sajulan</div>
                            <span className="title">Software Engineer</span>
                        </div>
                        <div className="team-member">
                            <div className="name">Rae Anne Camille Inoc</div>
                            <span className="title">Data Engineer / Support</span>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default TauriAboutUs;
